import { makeAutoObservable } from "mobx";

class SignupStore {
  email = "";
  token = "";
  next = "";
  firstName = "";
  lastName = "";
  country: string | undefined = undefined;
  phone = "";

  constructor() {
    makeAutoObservable(this);
  }

  set(email: string, token: string) {
    this.email = email;
    this.token = token;
  }

  setNext(next: string) {
    this.next = next;
  }

  setDetails(firstName: string, lastName: string, country: string, phone = "") {
    this.firstName = firstName;
    this.lastName = lastName;
    this.country = country;
    this.phone = phone;
  }

  clear() {
    this.email = "";
    this.token = "";
    this.next = "";
    this.firstName = "";
    this.lastName = "";
    this.country = undefined;
    this.phone = "";
  }
}

export const signupStore = new SignupStore();
